<template>
    <div class="header">
      <i @click="openMenu()" class="iconfont icon-menu hidden-sm-and-up"></i>
      <p class="headerTitle">JJLIN運營平台</p>
    </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  
  methods: {
    openMenu () {
      this.$emit('menuFlag',true);
    }
  }
};
</script>

<style lang="less" scoped>
  .header{
    width: 100%;
    position: fixed;
    display: flex;
    background: #fff;
    padding-right: 0.2rem;
    z-index: 99;
    justify-content: space-between;
    @media screen and (max-width:767px){
      padding-left: 0;
    }
    @media screen and (min-width:768px){
      padding-right: 2.2rem;
    }

    i.icon-menu{
      display: block;
      padding-left: 0.2rem;
      font-size: 0.5rem;
    }
    .headerTitle{
      width: 100%;
      text-align: right;
    }
  }
  @media screen and (max-width:768px){
    .header{
      height: 0.8rem;
      line-height:0.8rem;
      .headerTitle{
        font-size: 0.28rem;
      }
    }
  }
  @media screen and (min-width:769px){
    .header{
      height: 0.5rem;
      line-height: 0.5rem;
      .headerTitle{
        font-size: 0.14rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue